import { APP_CONFIG } from "../config/appConfig";

// FOR SET TITLE FOR THE APP
export const setPageTitle = (pageName) => {
    const appName = APP_CONFIG.APP_NAME;
    const tageLine = APP_CONFIG.TAG_LINE;
    document.title = `${appName} | ${pageName || tageLine}`;
};
